import {styled} from "@mui/material";

export const UserPageContent = styled('div')(() => ({
    width: '100%',
    top: '40px',
    position: 'relative'
}));

